export default __webpack_public_path__ + "static/media/beautiful-blurred-background-face-789304.7da096b7.jpg";